import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, rows = 3, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        "w-full rounded-md border border-border bg-surface px-3 py-2 text-[16px] text-text",
        "placeholder:text-text-muted leading-relaxed",
        "focus:outline-none focus:ring-2 focus:ring-[var(--focus-ring)] focus:border-primary",
        "disabled:bg-surface-2 disabled:cursor-not-allowed",
        className,
      )}
      {...rest}
    />
  );
});
